import { Product, Variant } from "../../types/types";
import { raise } from "../raise/raise";

export function getMainVariant(product: Product): Variant {
  const variants = product.variants;
  const defaultVariantId = product.defaultVariant.id;

  const mainVariant =
    getById(variants, defaultVariantId) ||
    raise("Main variant could not be found");

  return mainVariant;
}

function getById(variants: Variant[], id: string): Variant | undefined {
  return variants.find((variant) => variant.id === id);
}
